import React, { memo } from 'react';

import { Typography } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { CellContentType } from './CellContent.constants';

const CellContent = ({ type = CellContentType.PRIMARY, sourceValue, children }) => {
  if (_.isNil(sourceValue) || sourceValue === false) {
    return null;
  }

  switch (type) {
    case CellContentType.SECONDARY:
      return <Typography variant="regular12">{children}</Typography>;
    case CellContentType.PRIMARY:
    default:
      return (
        <Typography component="p" variant="medium16">
          {children}
        </Typography>
      );
  }
};

CellContent.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  sourceValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
};

export default memo(CellContent);
